// Entwürfe der Eingabeleiste (Notiz, Custom-Activity-Formulare) je Lead und Typ. Sie bleiben beim Wechseln
// der Reiter und der Leads erhalten, auch nach dem Neuladen der Seite (sessionStorage, je Browser-Tab).
const SCHLUESSEL = "crm-entwuerfe";
let speicher: Record<string, unknown> | null = null;
let zeitgeber: number | undefined;

function laden(): Record<string, unknown> {
  if (speicher) return speicher;
  try {
    speicher = JSON.parse(sessionStorage.getItem(SCHLUESSEL) ?? "{}") as Record<string, unknown>;
  } catch {
    speicher = {};
  }
  return speicher;
}

function sichern(): void {
  window.clearTimeout(zeitgeber);
  zeitgeber = window.setTimeout(() => {
    try {
      sessionStorage.setItem(SCHLUESSEL, JSON.stringify(speicher ?? {}));
    } catch {
      /* voll oder gesperrt: Entwürfe nur im Speicher */
    }
  }, 300);
}

export function entwurfLesen<T>(schluessel: string): T | undefined {
  return laden()[schluessel] as T | undefined;
}

export function entwurfSetzen(schluessel: string, wert: unknown): void {
  const s = laden();
  if (wert === undefined || wert === "" || (typeof wert === "object" && wert !== null && Object.keys(wert).length === 0)) delete s[schluessel];
  else s[schluessel] = wert;
  sichern();
}

/** Hat der Lead ungespeicherte Entwürfe? (Punkt am Reiter) */
export function hatEntwurf(schluessel: string): boolean {
  const w = laden()[schluessel];
  if (w === undefined || w === null || w === "") return false;
  if (typeof w === "object") return Object.values(w as Record<string, unknown>).some((x) => x !== null && x !== "" && !(Array.isArray(x) && x.length === 0));
  return true;
}

/** Alle Entwürfe dieses Tabs verwerfen (beim Abmelden und wenn sich ein anderer Nutzer anmeldet). */
export function entwuerfeLeeren(): void {
  window.clearTimeout(zeitgeber);
  speicher = {};
  try {
    sessionStorage.removeItem(SCHLUESSEL);
  } catch {
    /* gesperrt: nur im Speicher */
  }
}
